<template>
  <div class="dashboard-header">
    <b-row>
      <b-col>
        <icon-dashboard :width="26" :height="26" color="#FFD102"></icon-dashboard>
        <span class="Dashboard">Dashboard</span>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import IconDashboard from "@/components/common/icon/IconDashboard.vue";

@Component({
  name: "dashboard-header",
  components: {
    IconDashboard,
  },
})
export default class DashboardHeader extends Vue {
  constructor() {
    super();
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/prosegur/color";

.dashboard-header {
  padding: 14px 9px;
}

.Dashboard {
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.8;
  letter-spacing: normal;
  color: var(--secundario-prosegur-oscuro);
  bottom: 0;
  position: absolute;
  padding-left: 14px;
}
</style>
